/**
 * EntityContentTitle.jsx
 * Section title for entity page content
 * Migration from front/src/components/EntityContentTitle.js
 * Phase 4: Business components
 */
import React from 'react';
import { Typography } from '@mui/material';
import useTokenReplacement from '../hooks/ui/useTokenReplacement.js';

/**
 * Title component for entity content sections
 * @param {Object} props - Component props
 * @param {string} props.title - Title to display (with possible tokens)
 * @param {string} props.type - Entity type for token replacement
 * @param {Object} props.sx - Additional styles
 * @returns {JSX.Element} Styled section title
 */
const EntityContentTitle = ({
  title = '',
  type,
  sx = {},
  ...props
}) => {
  const replaceTokens = useTokenReplacement({ entityType: type });

  return (
    <Typography
      variant="h3"
      sx={{
        marginTop: '-50px',
        paddingTop: '80px',
        '@media print': {
          paddingTop: 0,
          marginTop: '5px',
          marginBottom: '5px',
          fontSize: '1.5em',
        },
        pageBreakBefore: 'always',
        ...sx,
      }}
      {...props}
    >
      {replaceTokens(title)}
    </Typography>
  );
};

EntityContentTitle.displayName = 'EntityContentTitle';

export default EntityContentTitle;
